import RoleList from "./List";
import RoleEdit from "./Edit";
export default [
    { exact: true, path: "/roles", component: RoleList },
    { exact: true, path: "/role/c", component: RoleEdit },
    { path: "/role/c/:cid/:duplicateRid", component: RoleEdit },
    { path: "/role/e/:cid/:rid", component: RoleEdit },
    { path: "/role/c/:cid", component: RoleEdit }
];
